import request from '@/utils/request'

// 登录方法
export function login(username, password, code, uuid) {
  return request({
    url: '/auth/login',
    headers: {
      isToken: false,
      repeatSubmit: false
    },
    method: 'post',
    data: { username, password, code, uuid }
  })
}

// 注册方法
export function register(data) {
  return request({
    url: '/pc-api/gys/register',
    // url: '/auth/register',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

// 刷新方法
export function refreshToken() {
  return request({
    url: '/auth/refresh',
    method: 'post'
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/system/user/getInfo',
    method: 'get'
  })
}

//
export function getDeptInfo(gysId) {
  return request({
    url: '/pc-api/index/getDeptInfo/' + gysId,
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/auth/logout',
    method: 'delete'
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/code',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}

// 微信登录
export function getLogin(query) {
	return request({
		url: '/pc-api/PCAuth/getLogin',
		method: 'get',
		params: query
	})
}

export function getPcLogin(query) {
	return request({
		url: '/pc-api/PCAuth/login',
		method: 'get',
		params: query
	})
}


//将私域id写入session
export function setSession() {
    return request({
        url: `/pc-api/index/setSession`,
        method: 'get',
    })
}

// 获取供应商
export function getSaas(query) {
	return request({
		url: '/pc-api/index/getSaas',
		method: 'get',
		params: query
	})
}

// 注册方法
// export function userregister(data) {
//   return request({
//     url: '/pc-api/index/register',
//     // url: '/auth/register',
//     headers: {
//       isToken: false
//     },
//     method: 'post',
//     data: data
//   })
// }

export function userregister(data, code, uuid) {
return request({
url: '/pc-api/index/register',
headers: {
isToken: false
},
method: 'post',
params: { // 这里使用params来传递URL参数（即query string）
code: code,
uuid: uuid
},
data: data // 请求体数据
})
}
